import { ShortMessageTemplatesMutations } from './partials/templates'

export const ShortMessageMutations = {
  ...ShortMessageTemplatesMutations,
}
